import { UserBinding } from './UserBinding';

export const Telemetry = {
  UserBinding,
};
